import { render, staticRenderFns } from "./BookingFeeTypeList.vue?vue&type=template&id=128006b0"
import script from "./BookingFeeTypeList.vue?vue&type=script&lang=js"
export * from "./BookingFeeTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports